import { useState } from 'react';
import { timeSlots } from '@/mocks/homeData';

export default function Timetable() {
  const [active, setActive] = useState(timeSlots[1]); // 默认周五晚
  const idx = timeSlots.findIndex((t) => t.id === active.id);

  return (
    <section id="schedule" className="scroll-mt-20 bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold tracking-widest text-primary-600">蹲瓜时间表</span>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-5xl">
            五个节点，<span className="text-primary-600">按点打卡</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600 md:text-lg">
            把一周和一月的娱乐话题节奏压缩成一张可预期的表。选定节点，看看这个时段里都藏着什么新料。
          </p>
        </div>

        {/* node step track */}
        <div className="mt-10 flex flex-col gap-3 lg:flex-row">
          {timeSlots.map((slot) => {
            const isActive = slot.id === active.id;
            return (
              <button
                key={slot.id}
                type="button"
                onClick={() => setActive(slot)}
                className={`flex items-center gap-3 rounded-xl border px-4 py-3 text-left transition ${
                  isActive
                    ? 'border-primary-500 bg-primary-500 text-background-50 shadow-lg shadow-primary-500/20'
                    : 'border-background-200 bg-background-50 text-foreground-800 hover:border-primary-300 hover:bg-background-100'
                }`}
              >
                <span className={`font-latin text-2xl leading-none ${isActive ? 'text-accent-300' : 'text-primary-400'}`}>
                  {slot.index}
                </span>
                <span className="flex-1">
                  <span className={`block font-heading font-bold ${isActive ? 'text-background-50' : 'text-foreground-950'}`}>
                    {slot.tag}
                  </span>
                  <span className={`block text-xs ${isActive ? 'text-background-100/80' : 'text-foreground-500'}`}>
                    {slot.tagEn}
                  </span>
                </span>
                <i className={`ri-arrow-right-s-line text-xl ${isActive ? 'text-background-100' : 'text-foreground-400'}`} />
              </button>
            );
          })}
        </div>

        {/* detail panel */}
        <div className="mt-8 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className="relative flex flex-col justify-center gap-3 overflow-hidden bg-foreground-950 p-8 md:p-10 lg:col-span-2">
              <span className="absolute -right-6 -top-10 font-latin text-[7rem] leading-none text-background-50/5 md:text-[8.5rem]">
                {active.index}
              </span>
              <span className="font-latin text-sm tracking-[0.3em] text-accent-400">{active.tagEn}</span>
              <h3 className="relative font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                {active.name}
              </h3>
              <p className="relative text-sm text-background-100/75">{active.subtitle}</p>
              <div className="relative mt-1 flex items-center gap-2 rounded-lg bg-background-50/10 px-3 py-2 text-sm text-background-100">
                <i className="ri-alarm-fill text-accent-400" />
                <span className="flex-1">{active.timeline}</span>
              </div>
            </div>

            <div className="flex flex-col justify-center gap-5 p-7 md:p-10 lg:col-span-3">
              <div>
                <div className="mb-2 flex items-center gap-2 text-sm font-medium text-primary-600">
                  <i className="ri-article-line" />
                  本节点聚焦
                </div>
                <p className="text-base leading-relaxed text-foreground-700">{active.desc}</p>
              </div>

              <div>
                <div className="mb-2 text-sm font-medium text-foreground-800">蹲守重点</div>
                <div className="flex flex-wrap gap-2">
                  {active.focus.map((f) => (
                    <span key={f} className="rounded-full bg-accent-100 px-3 py-1.5 text-sm text-accent-900">
                      {f}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex items-start gap-2 rounded-xl border border-primary-200 bg-primary-50 px-4 py-3 text-sm text-primary-800">
                <i className="ri-megaphone-fill mt-0.5 shrink-0 text-primary-600" />
                <span>{active.alert}</span>
              </div>

              <div className="mt-1 flex items-center gap-1.5 text-sm text-foreground-500">
                <span>当前正在查看</span>
                <span className="flex items-center gap-0.5 text-foreground-800">
                  {timeSlots.map((_, i) => (
                    <i
                      key={i}
                      className={`ri-radio-button-line ${i === idx ? 'text-primary-500' : 'text-background-300'}`}
                    />
                  ))}
                </span>
                <span className="font-medium text-primary-600">{idx + 1} / {timeSlots.length}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}